import { QuotaLevels } from "../enums/reservation.enum";

export const normalizeText = (str: string) => {
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const getQuotaColor = (quotaAvailability: number) => {
    switch (true) {
        case quotaAvailability === QuotaLevels.HIGH:
            return 'green'
        case quotaAvailability === QuotaLevels.MID:
            return 'orange'
        case quotaAvailability === QuotaLevels.LOW:
            return 'red'
        case quotaAvailability === QuotaLevels.NONE:
            return 'gray'
        default:
            return 'gray'
    }
}

export function copyTextToClipboard(text: string){
  navigator.clipboard.writeText(text)
};

export const parseHours = (time: number) => {
  const hour = String(time).split("");
  const minutes = hour.splice(-2).join("");
  return `${hour.join("")}:${minutes}`;
};

export function decodeJWT(token: string) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decodificando el token:', error);
      return null;
    }
  }

  export const formatearJSON = (jsonText: string) => {
    try {
      const objeto = JSON.parse(jsonText);
      const formateado = JSON.stringify(objeto, null, 3);
      return formateado;
    } catch (error: any) {
      console.error('JSON inválido:', error.message);
      return jsonText;
    }
  };

  export const validarJSON = (jsonString: string) => {
    try {
      JSON.parse(jsonString);
      return { esValido: true, error: null };
    } catch (error: any) {
      return { 
        esValido: false, 
        error: error.message 
      };
    }
  };